import { render, staticRenderFns } from "./ModalPostcode.vue?vue&type=template&id=7eb6a4a0&"
import script from "./ModalPostcode.vue?vue&type=script&lang=js&"
export * from "./ModalPostcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports